var render, staticRenderFns
import script from "./CheckedModels.vue?vue&type=script&lang=js&"
export * from "./CheckedModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f25d0",
  null
  
)

export default component.exports